import { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { notification } from 'antd';

// services
import * as SubscriptionService from '../../../../services/bb-api/subscription';

type Props = { country?: number  }

export const Subscribers: React.FC<Props> = ({ country }) => {
  const [activeSubs, setActiveSubs] = useState<number>(0);
  const [activeSubsToday, setActiveSubsToday] = useState<number>(0);
	const [activeSubsYesterday, setActiveSubsYesterday] = useState<number>(0);

	const getData = useCallback(() => {
		try {
			SubscriptionService.activeSubscriptions('all', country).then(setActiveSubs);
			SubscriptionService.activeSubscriptions('24h', country).then(setActiveSubsToday);
			SubscriptionService.activeSubscriptions('48h', country).then(setActiveSubsYesterday);
		} catch (error) {
			const message = 'Der skete en fejl';
			notification.error({ message });
		}
	}, [])

	useEffect(() => {
		getData();
		const intervalTime = 20 * 1000 // 20 seconds
		const intervalId = setInterval(getData, intervalTime)
		return () => clearInterval(intervalId)
	}, [getData]);

	return (
		<StyledContainer className='subscribers'>
			{/* Subscribers: Total / Today / Yesterday */}
			<div className='flex-item'>
				<div className='num-container'>
					<p className='label'>Total</p>
					<h1>{activeSubs.toLocaleString()}</h1>
				</div>
				<div className='num-container'>
					<p className='label'>I dag</p>
					<h1>{activeSubsToday.toLocaleString()}</h1>
				</div>
				<div className='num-container'>
					<p className='label'>I går</p>
					<h1>{(activeSubsYesterday - activeSubsToday).toLocaleString()}</h1>
				</div>
			</div>
		</StyledContainer>
	);
};

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	color: #9ca3af;

	h1 {
		font-size: 84px;
		font-weight: 700;
		line-height: 1em;
    color: #ffffff;
		margin: 0;
	}

	p {
		margin: 0;
	}

	.label {
		font-size: 32px;
		margin: 0;
	}

	.flex-item {
		display: flex;
		flex-direction: column;
	}

	.num-container {
		display: flex;
		flex: 1;
		flex-direction: column;
		background-color: rgba(31, 41, 55, 1);
		height: 180px;
		margin: 1em;
		padding: 12px 48px;
		border-radius: 12px;
		box-shadow: rgba(0,0,0,0.2) 0px 2px 8px 0px;
	}
`;
